// Ported from packages/desk/src/mobile/SystemBar.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/**
 * The top of the phone home screen: the workspace's name, compact (a name, not a banner), a subtitle under it, an
 * optional bell, and the avatar that opens Profile. It clears the notch. `avatar` (a drawn picture) takes the place of
 * the initials when given: a Radar addition, to copy back to the desk.
 */
import type { ReactNode } from "react";
import { BellGlyph } from "./glyphs";
import { formatBadge } from "./layout";

export function SystemBar({
  title,
  subtitle,
  initials,
  avatar,
  bell,
  onProfile,
}: {
  title: string;
  subtitle?: string | undefined;
  initials: string;
  avatar?: ReactNode;
  bell?: { count: number; label: string; onOpen: () => void } | undefined;
  onProfile: () => void;
}) {
  const b = formatBadge(bell?.count);
  return (
    <header className="rdr-msys" data-rdr-system-bar="">
      <div className="rdr-msys-names">
        <p className="rdr-msys-title" data-rdr-title="">
          {title}
        </p>
        {subtitle && <p className="rdr-msys-sub">{subtitle}</p>}
      </div>
      {bell && (
        <button type="button" className="rdr-msys-btn" aria-label={b.kind === "count" ? `${bell.label}, ${b.n} new` : bell.label} onClick={bell.onOpen}>
          <BellGlyph />
          {b.kind === "count" && <span className="rdr-mbadge">{b.text}</span>}
        </button>
      )}
      <button type="button" className="rdr-msys-avatar" aria-label="Profile" data-rdr-avatar="" onClick={onProfile}>
        <span aria-hidden="true" className={avatar ? "art" : undefined}>
          {avatar ?? initials}
        </span>
      </button>
    </header>
  );
}
